import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function RoleMenuPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const tipoUsuario = user?.tipoUsuario || "";
  const tipos = tipoUsuario.split(",").map((t) => t.trim());

  const handleRoleClick = (role) => {
    if (role === "Vendedor") navigate("/vendor");
    if (role === "Comprador") navigate("/"); // ejemplo, ir al home
    if (role === "Bloguero") navigate("/blog"); // ejemplo, blog
    if (role === "Video Bloguero") navigate("/video-blog");
  };

  const isEnabled = (typeNum) => tipos.includes(typeNum.toString());

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100 bg-light"
      style={{ fontFamily: "'Poppins', sans-serif" }}
    >
      <div
        className="card shadow-lg border-0 rounded-4 p-5 text-center"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <h2 className="fw-bold text-primary mb-4">Selecciona tu rol</h2>

        <div className="d-grid gap-3">
          <button
            className={`btn btn-outline-primary rounded-pill py-2 fw-semibold ${
              !isEnabled(0) ? "disabled opacity-50" : ""
            }`}
            onClick={() => isEnabled(0) && handleRoleClick("Vendedor")}
          >
            🛍️ Vendedor
          </button>

          <button
            className={`btn btn-outline-success rounded-pill py-2 fw-semibold ${
              !isEnabled(1) ? "disabled opacity-50" : ""
            }`}
            onClick={() => isEnabled(1) && handleRoleClick("Comprador")}
          >
            🛒 Comprador
          </button>

          <button
            className={`btn btn-outline-warning rounded-pill py-2 fw-semibold ${
              !isEnabled(2) ? "disabled opacity-50" : ""
            }`}
            onClick={() => isEnabled(2) && handleRoleClick("Bloguero")}
          >
            ✍️ Bloguero
          </button>

          <button
            className={`btn btn-outline-info rounded-pill py-2 fw-semibold ${
              !isEnabled(3) ? "disabled opacity-50" : ""
            }`}
            onClick={() => isEnabled(3) && handleRoleClick("Video Bloguero")}
          >
            🎥 Video Bloguero
          </button>
        </div>

        <hr className="my-4" />

        <button
          className="btn btn-danger rounded-pill px-4 shadow-sm fw-semibold"
          onClick={handleLogout}
        >
          🚪 Cerrar sesión
        </button>
      </div>
    </div>
  );
}

export default RoleMenuPage;
